import React, { useState, useEffect, createContext } from "react";
import "./index.scss";
import { postRequest } from "../../../utilities/api";

import { chunk } from "react-chunk";

import { number } from "../../../utilities/helpers";

import { Layout } from "antd";

const Affix = chunk(() => import("./components/Affix"))();
const ImageOrderNo = chunk(() => import("./components/ImageOrderNo"))();
const Description = chunk(() => import("./components/Description"))();
const Redirect = chunk(() => import("./components/Redirect"))();

export const OrderPlacedContext = createContext();

export default function OrderPlaced(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const purchaseOrder = async () => {
      const { po_id } = props.match.params;
      try {
        let response = await postRequest("purchaseOrder/" + po_id);
        let data = await response.data;
        setData(data);
      } catch (e) {
        console.log("error purchaseorder request", e);
      }
    };
    purchaseOrder();
    return () => {
      console.log("purchaseOrder unmounting...");
    };
  }, []);

  const renderValue = (type) => {
    if (data[0] !== undefined) {
      const {
        total_amount,
        order_number,
        delivery_date,
        total_vat,
        pickup_date,
      } = data[0];



      switch (type) {
        case "totalAmount":
          return number(total_amount).comma();
        case "totalVat":
          return number(total_vat).comma();
        case "subTotal":
          return Number(total_amount - total_vat).toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        case "orderNumber":
          return order_number;
        case "deliveryDate":
          return delivery_date;
        case "pickupDate":
          return pickup_date;
      }
    }
  };

  return (
    <Layout className="order-placed">
      <Layout.Content className="order-placed-content">
        <OrderPlacedContext.Provider
          value={{
            data,
            renderValue,
            poId: props.match.params.po_id,
          }}
        >
          <div>
            <Affix />
            <ImageOrderNo />
            <Description />
            <Redirect />
          </div>
        </OrderPlacedContext.Provider>
      </Layout.Content>
    </Layout>
  );
}
